import { PROFILE_UPDATE } from "@/graphql/mutations/profile";
import { PROFILE } from "@/graphql/queries/profile";
import { useMutation, useQuery } from "@apollo/client";
import { useAppGlobal } from "../app/AppGlobalProvider";
import { getSupportId, setSupportId, setSupportUser } from "@/utils/support";
import { useEffect } from "react";
import { localStorageWrapper } from "@/utils/storage";

export default function useGoftino(activeChatWidget) {
    const [updateProfile] = useMutation(PROFILE_UPDATE);
    const { data: { profile } = {} } = useQuery(PROFILE, {
        fetchPolicy: "cache-first",
    });

    const {
        isGoftinoReady,
        isGoftinoOpen,
        isSupportUserSynced,
        goftinoSendMessageCounter,
        goftinoGetMessageCounter,
        setSupportUserIsSynced,
    } = useAppGlobal();

    useEffect(() => {
        // Only run if this is the active chat widget
        if (activeChatWidget !== "Goftino") {
            return;
        }

        if (!localStorageWrapper.isImpersonated() && profile?.userId) {
            const cachedSupportId = getSupportId();
            const userSupportId = profile?.supportId;

            if (userSupportId && userSupportId !== cachedSupportId) {
                setSupportId(userSupportId);
            }

            if (isGoftinoReady) {
                setSupportUser(profile);
            }

            if (
                isGoftinoReady &&
                isGoftinoOpen &&
                !userSupportId &&
                !isSupportUserSynced
            ) {
                const supportId = getSupportId();
                if (supportId) {
                    {
                        updateProfile({
                            variables: {
                                input: {
                                    id: parseInt(profile?.userId),
                                    supportId: supportId,
                                },
                            },
                            onCompleted: () => {
                                setSupportUserIsSynced();
                            },
                        });
                    }
                }
            }
        }
    }, [
        activeChatWidget,
        profile,
        isGoftinoReady,
        isGoftinoOpen,
        goftinoSendMessageCounter,
        goftinoGetMessageCounter,
    ]);
}
